import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';




@Component({
  selector: 'app-dynamic-filter-data-drag-drop',
  templateUrl: './dynamic-filter-data-drag-drop.component.html',
  styleUrls: ['./dynamic-filter-data-drag-drop.component.scss']
})
export class DynamicFilterDataDragDropComponent implements OnInit, OnDestroy, AfterViewInit {
  
  @ViewChild('container') container: ElementRef;
  @Input() itemsList:any[];
  @Input() selectedItems:any[];
  @Input() filteredItems:any[];
  @Input() multipleItems:boolean;
  @Input() searchKey:string;
  @Input() isPDP:boolean = false;
  
  
  @Output() newSearchEvent = new EventEmitter<string>();
  @Output() newSelectSearchEvent = new EventEmitter<string>();
  @Output() dataFilterModelChange = new EventEmitter<string>();
  @Output() listsChanged = new EventEmitter<{itemsList: any[], selectedItems: any[]}>();

  isMobile: boolean;
  resizeObserver: ResizeObserver;
  containerWidth: number;

  tempSelectedList:any[];

  searchSelectedText:string;

  events = [];
  
  constructor( private cdr: ChangeDetectorRef) { 
  }

  ngOnInit(): void {
   // this.updateFilterData();
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect(); // Clean up the observer to prevent memory leaks
    }
  }

  ngAfterViewInit() {
    this.setupResizeObserver();
  }

 
  setupResizeObserver(): void {
    
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        // Check for changes in the width property
        const { width } = entry.contentRect;
        //console.log(`Element's width is now ${width}`);
        // Call your function to handle width change here
        this.updateContainerWidth(width);
      }
    });

    // Start observing the element
    this.resizeObserver.observe(this.container.nativeElement);
  }


  updateContainerWidth(width) {
    this.containerWidth = width;
    this.updateIsMobile();
  }


  updateIsMobile() {
    // Use 500px threshold for container-based detection (works better in modals)
    this.isMobile = this.containerWidth <= 500;
    this.cdr.detectChanges();
  }
  
  clearEvents(): void {
    this.events = [];
  }

  // Handle image loading errors - mark item to show placeholder
  onImageError(item: any): void {
    if (item) {
      item._imageError = true;
    }
  }

  itemsRemoved(ev, list) {
    this.tempSelectedList = [];
    //this.events.push({text: `itemsRemoved from ${list}`, ev: JSON.stringify(ev)});
  }

  itemsAdded(ev, list) {
    if (!Array.isArray(ev) || ev.length === 0) return;

    // List 1 = DISPONIBLE (items dropped TO available list, coming FROM selected)
    if (list === 1) {
      ev.forEach(item => {
        // Add to itemsList if not already present
        if (!this.itemsList.find(x => x.id === item.id)) {
          this.itemsList.push(item);
        }
        // Remove from selectedItems
        const idx = this.selectedItems.findIndex(x => x.id === item.id);
        if (idx > -1) {
          this.selectedItems.splice(idx, 1);
        }
        // Remove from filteredItems
        const filteredIdx = this.filteredItems.indexOf(item.id);
        if (filteredIdx > -1) {
          this.filteredItems.splice(filteredIdx, 1);
        }
      });
      console.log('Items moved back to available (itemsList):', this.itemsList);
    }
    // List 2 = SELECCIONADO (items dropped TO selected list, coming FROM available)
    else if (list === 2) {
      if (this.isPDP && ev.length) {
        // If single-selection mode, keep only the first item
        const newItem = ev[0];
        // Move previously selected back to available
        if (this.selectedItems.length) {
          const prev = this.selectedItems[0];
          if (!this.itemsList.find(x => x.id === prev.id)) {
            this.itemsList.push(prev);
          }
          this.selectedItems.splice(0, this.selectedItems.length);
        }
        ev = [newItem];
      }
      
      ev.forEach(item => {
        // Add to selectedItems if not already present
        if (!this.selectedItems.find(x => x.id === item.id)) {
          this.selectedItems.push(item);
        }
        // Remove from itemsList
        const idx = this.itemsList.findIndex(x => x.id === item.id);
        if (idx > -1) {
          this.itemsList.splice(idx, 1);
        }
      });
      console.log('Items added to selected (selectedItems):', this.selectedItems);
    }

    this.updateFilterData();
    this.tempSelectedList = [];
    // Force Angular change detection
    this.selectedItems = [...this.selectedItems];
    this.itemsList = [...this.itemsList];
    this.listsChanged.emit({itemsList: this.itemsList, selectedItems: this.selectedItems});
  }

  itemsUpdated(ev, list) {
    //  pour notifier le parent du nouvel ordre
    this.listsChanged.emit({ itemsList: this.itemsList, selectedItems: this.selectedItems });
    this.tempSelectedList = [];
  }


  updateFilterData(){
    //this.filteredItems =[];
    for (let index = 0; index < this.selectedItems.length; index++) {
      if(this.filteredItems.indexOf(this.selectedItems[index].id) === -1)
        this.filteredItems.push(this.selectedItems[index].id);
    }
    this.dataFilterModelChange.emit();
  }

  AvailableSelectionChanged(ev, list) {
    this.tempSelectedList = ev;
   // console.log("gettin selected element");
    //console.log(ev);
    //console.log(list);
  }

  SelectedSelectionChanged(evnt, index){
    console.log("gettin selected element");
    console.log(evnt);
    console.log(index);
  }


  searchAvailableEvent(event){
    this.newSearchEvent.emit(event);
  }


  moveItemTo(){
    // If PDP single selection: only move first selected and ensure swap
    if(this.isPDP && this.tempSelectedList && this.tempSelectedList.length){
      const item = this.tempSelectedList[0];
      // Put previous selected back
      if(this.selectedItems.length){
        const prev = this.selectedItems[0];
        if(!this.itemsList.find(x=>x.id===prev.id)){
          this.itemsList.push(prev);
        }
        this.selectedItems=[];
      }
      if(!this.selectedItems.find(x=>x.id===item.id)){
        this.selectedItems.push(item);
        const idx=this.itemsList.findIndex(x=>x.id===item.id);
        if(idx>-1){this.itemsList.splice(idx,1);}    
      }
      this.tempSelectedList=[];
      this.updateFilterData();
      this.selectedItems=[...this.selectedItems];
      this.itemsList=[...this.itemsList];
      this.listsChanged.emit({itemsList:this.itemsList,selectedItems:this.selectedItems});
      return;
    }

    if(this.tempSelectedList){
      for (let index = 0; index <  this.tempSelectedList.length; index++) {
        const item = this.tempSelectedList[index];
        if(!this.selectedItems.find((x)=> x.id == item.id)){
          this.selectedItems.push(item);
          const idx = this.itemsList.findIndex(x => x.id === item.id);
          if (idx > -1) {
            this.itemsList.splice(idx, 1);
          }
        }
      }
      this.tempSelectedList = [];
      this.updateFilterData();
      // Force la détection du changement Angular
      this.selectedItems = [...this.selectedItems];
      this.itemsList = [...this.itemsList];
      this.listsChanged.emit({itemsList: this.itemsList, selectedItems: this.selectedItems});
    }
   

  }

  removeItem(item:any){
    // Remove from selectedItems
    const index = this.selectedItems.findIndex((x) => x.id == item.id);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    }
    // Remove from filteredItems (if present)
    const filteredIdx = this.filteredItems.indexOf(item.id);
    if (filteredIdx > -1) {
      this.filteredItems.splice(filteredIdx, 1);
    }
    // Add back to itemsList if not already present
    if (!this.itemsList.find((x) => x.id == item.id)) {
      this.itemsList.push(item);
    }
    // Remove duplicates from itemsList
    this.itemsList = this.itemsList.filter((itemObj, idx, arr) => arr.findIndex(x => x.id === itemObj.id) === idx);
    // Do NOT filter out items just moved back, so they show up immediately
    this.updateFilterData();
    // Force change detection
    this.selectedItems = [...this.selectedItems];
    this.itemsList = [...this.itemsList];
    this.cdr.detectChanges();
    this.listsChanged.emit({ itemsList: this.itemsList, selectedItems: this.selectedItems });
    console.log('Produit déplacé à gauche (itemsList):', item);
  }
}
